var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Finish signing up by clicking the link in the email that was just sent to you.")])}
var staticRenderFns = []

export { render, staticRenderFns }